// object-fit-polyfillはcontainerに高さ指定が必要のため、高さを指定する
// https://github.com/constancecchen/object-fit-polyfill#usage
export class ObjectFitSupport {
  private readonly $element: JQuery;

  public static init(): void {
    // objectFitPolyfillが処理しない場合は、skip
    if(this.usingObjectFitPolyfill() === false) {
      return;
    }

    $(".js-object-fit").each((_index, element) => {
      new ObjectFitSupport(element).init();
    });
  }

  public static usingObjectFitPolyfill(): boolean {
    return window.objectFitPolyfill();
  }

  constructor(element: HTMLElement) {
    this.$element = $(element);
  }

  public init(): void {
    this.$element.height(this.getHeight());
  }

  private getHeight(): string {
    return this.$element.data("height");
  }
}
